import {
    skittleCalloutNarratorWithSuggestions,
    skittleCalloutNarratorNoSuggestions,
    skittleCalloutNarratorWithOneSuggestion,
    premiumPreviewAriaLableSkittleOnCount,
    premiumPreviewAriaLableSkittleOnDays,
} from '../components/SkittleCallout.locstring.json';
import loc, { format } from 'owa-localize';
import {
    PremiumPreviewStatus,
    PremiumPreviewData,
    PremiumPreviewType,
} from '../store/schema/PremiumPreviewData';

export function getAriaLabelForSkittle(
    numberOfSuggestions: number,
    premiumPreviewData: PremiumPreviewData
): string {
    const {
        premiumSuggestionsCount,
        numberOfDaysLeftToUsePremiunSuggestions,
        premiumPreviewStatus,
        premiumPreviewType,
    } = premiumPreviewData;
    if (premiumPreviewStatus === PremiumPreviewStatus.Activated) {
        if (premiumPreviewType === PremiumPreviewType.TimeBased) {
            return format(
                loc(premiumPreviewAriaLableSkittleOnDays),
                numberOfDaysLeftToUsePremiunSuggestions.toString()
            );
        }
        if (premiumPreviewType === PremiumPreviewType.CountBased) {
            return format(
                loc(premiumPreviewAriaLableSkittleOnCount),
                premiumSuggestionsCount.toString()
            );
        }
    }

    if (numberOfSuggestions === 1) {
        return loc(skittleCalloutNarratorWithOneSuggestion);
    }
    if (numberOfSuggestions > 1) {
        return format(loc(skittleCalloutNarratorWithSuggestions), numberOfSuggestions.toString());
    }

    return loc(skittleCalloutNarratorNoSuggestions);
}
